import { Meeting } from '@models';

export interface ProjectMeetingResult {
  projectMeeting: Meeting[];
}
